export const MEASUREMENT_TYPES = [
  {
    value: 'trial',
    label: 'Trial (acerto/erro/ajuda)',
    short: 'Trial',
    hint: 'Cada tentativa é registrada como acerto, erro ou com ajuda.',
  },
  {
    value: 'frequency',
    label: 'Frequência',
    short: 'Frequência',
    hint: 'Conta quantas vezes o comportamento ocorreu na sessão.',
  },
  {
    value: 'duration',
    label: 'Duração',
    short: 'Duração',
    hint: 'Cronometra quanto tempo cada episódio durou.',
  },
  {
    value: 'latency',
    label: 'Latência',
    short: 'Latência',
    hint: 'Tempo entre a instrução (SD) e o início da resposta.',
  },
  {
    value: 'percentage',
    label: 'Percentual',
    short: 'Percentual',
    hint: 'Acertos sobre oportunidades (ex.: 8 de 10 passos da tarefa).',
  },
  {
    value: 'interval',
    label: 'Intervalo',
    short: 'Intervalo',
    hint: 'Marca se o comportamento ocorreu a cada intervalo de tempo.',
  },
  {
    value: 'manual',
    label: 'Manual',
    short: 'Manual',
    hint: 'Anotação livre da observação durante a sessão.',
  },
];

export const INTERVAL_TYPES = [
  { value: 'partial', label: 'Intervalo parcial', hint: 'Ocorreu em qualquer momento do intervalo.' },
  { value: 'whole', label: 'Intervalo total', hint: 'Ocorreu durante todo o intervalo.' },
  { value: 'momentary', label: 'Amostragem momentânea', hint: 'Ocorria no instante final do intervalo.' },
];

export const DEFAULT_INTERVAL_SECONDS = 30;

export function measurementType(type) {
  return MEASUREMENT_TYPES.find((option) => option.value === (type || 'trial'));
}

export function measurementShort(type) {
  return measurementType(type)?.short || type;
}

export function intervalTypeLabel(type) {
  return INTERVAL_TYPES.find((option) => option.value === type)?.label || 'Intervalo parcial';
}

/** Segundos em formato legível: 45s, 1m 30s, 1h 05m. */
export function formatSeconds(value) {
  const seconds = Number(value);
  if (!Number.isFinite(seconds)) return '—';

  if (seconds < 10) {
    return Number.isInteger(seconds) ? `${seconds}s` : `${seconds.toFixed(1)}s`;
  }

  const rounded = Math.round(seconds);
  if (rounded < 60) return `${rounded}s`;

  const hours = Math.floor(rounded / 3600);
  const minutes = Math.floor((rounded % 3600) / 60);
  const rest = rounded % 60;

  if (hours > 0) return `${hours}h ${String(minutes).padStart(2, '0')}m`;
  return rest > 0 ? `${minutes}m ${String(rest).padStart(2, '0')}s` : `${minutes}m`;
}

/** Cronômetro no formato mm:ss (ou h:mm:ss). */
export function clockFormat(value) {
  const total = Math.max(0, Math.round(Number(value) || 0));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  const base = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

  return hours > 0 ? `${hours}:${base}` : base;
}

export function formatStatValue(stat) {
  if (!stat || stat.value === null || stat.value === undefined) return '—';
  if (stat.format === 'seconds') return formatSeconds(stat.value);
  if (stat.format === 'percent') return `${stat.value}%`;

  return String(stat.value);
}

/** Valor principal da sessão/dia já formatado conforme a métrica. */
export function formatMetricValue(value, metric) {
  if (value === null || value === undefined) return '—';
  if (metric === 'percent') return `${value}%`;
  if (metric === 'seconds' || metric === 'mean_seconds') return formatSeconds(value);

  return String(value);
}

export function metricAxisLabel(metric) {
  if (metric === 'percent') return '%';
  if (metric === 'seconds') return 'Tempo total';
  if (metric === 'mean_seconds') return 'Tempo médio';

  return 'Ocorrências';
}
